import React, { useEffect, useState, useRef } from 'react';
import { CheckCircle, Mail, Phone, ArrowLeft } from 'lucide-react';
import { Link, useSearchParams } from 'react-router-dom';
import './ThankYou.css';

function ThankYou() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [sessionDetails, setSessionDetails] = useState(null);
  const hasConfirmed = useRef(false); // Anti-doublon (React StrictMode appelle useEffect 2x)

  useEffect(() => {
    // Confirmer le paiement et envoyer l'alerte Slack
    const confirmPayment = async () => {
      // Protection contre les appels multiples
      if (!sessionId || hasConfirmed.current) return;
      hasConfirmed.current = true;
      
      // Vérifier si déjà traité dans localStorage
      const confirmedSessions = JSON.parse(localStorage.getItem('confirmedSessions') || '[]');
      if (confirmedSessions.includes(sessionId)) {
        console.log('Session déjà confirmée:', sessionId);
        return;
      }
      
      try {
        const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3000';
        const response = await fetch(`${backendUrl}/demo-leads/confirm-payment/${sessionId}`);
        const data = await response.json();
        
        if (data.result) {
          console.log('Paiement confirmé:', data.customer);
          setSessionDetails(data.customer);
          
          // Marquer comme confirmé dans localStorage
          confirmedSessions.push(sessionId);
          localStorage.setItem('confirmedSessions', JSON.stringify(confirmedSessions));
        }
      } catch (error) {
        console.error('Erreur confirmation paiement:', error);
        hasConfirmed.current = false; // Permettre un retry en cas d'erreur
      }
    };
    
    confirmPayment();
  }, [sessionId]);

  return (
    <div className="thank-you">
      <div className="thank-you__container">
        {/* Logo */}
        <img 
          src="/images/logo-procumatcher.png" 
          alt="ProcuMatcher" 
          className="thank-you__logo"
        />

        {/* Icône de succès */}
        <div className="thank-you__icon">
          <CheckCircle size={64} />
        </div>

        {/* Message principal */}
        <h1 className="thank-you__title">
          Paiement confirmé !
        </h1>
        
        <p className="thank-you__subtitle">
          Merci pour votre confiance. Votre ProcuMatcher de campagne est en cours de création.
        </p>

        {/* Timeline des prochaines étapes */}
        <div className="thank-you__steps">
          <h2 className="thank-you__steps-title">Prochaines étapes</h2>
          
          <div className="thank-you__step">
            <div className="thank-you__step-number">1</div>
            <div className="thank-you__step-content">
              <h3>Confirmation par email</h3>
              <p>Vous recevrez un email de confirmation avec votre facture dans les prochaines minutes.</p>
            </div>
          </div>
          
          <div className="thank-you__step">
            <div className="thank-you__step-number">2</div>
            <div className="thank-you__step-content">
              <h3>Contact de notre équipe</h3>
              <p>Notre équipe vous contactera sous 24h pour configurer votre espace ProcuMatcher.</p>
            </div>
          </div>
          
          <div className="thank-you__step">
            <div className="thank-you__step-number">3</div>
            <div className="thank-you__step-content">
              <h3>Formation et lancement</h3>
              <p>Une formation gratuite vous sera proposée pour maîtriser l'outil en moins d'une heure.</p>
            </div>
          </div>
        </div>

        {/* Contact */}
        <div className="thank-you__contact">
          <h3>Une question ?</h3>
          <div className="thank-you__contact-links">
            <a href="mailto:contact@rodium.fr" className="thank-you__contact-link">
              <Mail size={18} />
              contact@rodium.fr
            </a>
            <a href="tel:0142560944" className="thank-you__contact-link">
              <Phone size={18} />
              01 42 56 09 44
            </a>
          </div>
        </div>

        {/* Retour */}
        <Link to="/" className="thank-you__back">
          <ArrowLeft size={18} />
          Retour à l'accueil
        </Link>
      </div>
    </div>
  );
}

export default ThankYou;

